// extracted by mini-css-extract-plugin
module.exports = {"container":"FixedRight-module--container--3qrE5","wrap":"FixedRight-module--wrap--nrMnH","purple":"FixedRight-module--purple--3eo4r","red":"FixedRight-module--red--DEFXF"};